var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _line, _line2, _line3, _line4, _line5, _line6, _rect, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 95,
    viewBox: "0 0 94 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2305 54.2599C22.2305 56.6292 20.3098 58.5499 17.9405 58.5499C15.5712 58.5499 13.6505 56.6292 13.6505 54.2599C13.6505 51.8906 15.5712 49.9699 17.9405 49.9699C20.3098 49.9699 22.2305 51.8906 22.2305 54.2599Z",
    stroke: "white",
    strokeWidth: 2.34
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9492 54.2599C79.9492 56.6292 78.0285 58.5499 75.6592 58.5499C73.2899 58.5499 71.3692 56.6292 71.3692 54.2599C71.3692 51.8906 73.2899 49.9699 75.6592 49.9699C78.0285 49.9699 79.9492 51.8906 79.9492 54.2599Z",
    stroke: "white",
    strokeWidth: 2.34
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8698 26.57C51.8698 29.1547 49.7745 31.25 47.1898 31.25C44.6052 31.25 42.5098 29.1547 42.5098 26.57C42.5098 23.9853 44.6052 21.89 47.1898 21.89C49.7745 21.89 51.8698 23.9853 51.8698 26.57Z",
    stroke: "white",
    strokeWidth: 2.34
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9393 35.9301L17.6836 49.7655C16.1055 50.21 15.1922 51.0348 14.4293 51.53L10.5293 48.4101L14.4293 35.9301H17.9393Z",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8007 2L46.5046 21.3696C44.6774 21.992 43.6198 23.1467 42.7365 23.84L38.2207 19.472L42.7365 2H46.8007Z",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.833 39.0705L52.2065 29.1293C52.5811 27.2357 52.1099 25.7424 51.9512 24.6308L57.9919 22.904L70.8652 35.5508L68.833 39.0705Z",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7393 39.4401L42.6619 30.0117C44.1145 31.283 45.6433 31.6215 46.6854 32.0398L45.1605 38.1346L27.7714 42.9598L25.7393 39.4401Z",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8841 63.6753L21.9431 56.6828C22.3275 55.089 22.0551 53.8889 21.9964 52.9813L26.6257 51.1066L35.6015 60.6142L33.8841 63.6753Z",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56063 63.6197L13.6703 56.9235C14.8444 58.0678 16.0153 58.4464 16.8256 58.8595L16.0736 63.797L3.31563 66.6595L1.56063 63.6197Z",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.165 64.4566L71.5475 57.0059C71.1433 55.3772 71.4225 54.1382 71.4807 53.2045L66.6662 51.3822L57.3716 61.3504L59.165 64.4566Z",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6583 35.54L75.9196 49.989C77.5322 50.4533 78.4655 51.3146 79.2451 51.8318L83.2305 48.5734L79.2451 35.54L75.6583 35.54Z",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9951 63.9657L79.3513 56.9676C78.1429 58.132 76.9303 58.5096 76.0926 58.9261L76.9217 64.0067L90.2017 67.072L91.9951 63.9657Z",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.0952,
    y1: 88.4673,
    x2: 14.4352,
    y2: 64.2873,
    stroke: "white",
    strokeWidth: 2.34
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 69.8166,
    y1: 88.4606,
    x2: 72.9366,
    y2: 58.0406,
    stroke: "white",
    strokeWidth: 2.34
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 23.7951,
    y1: 88.6993,
    x2: 20.6751,
    y2: 58.2793,
    stroke: "white",
    strokeWidth: 2.34
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 81.5151,
    y1: 88.6927,
    x2: 79.1751,
    y2: 64.5127,
    stroke: "white",
    strokeWidth: 2.34
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 37.8369,
    y1: 88.4527,
    x2: 43.2969,
    y2: 38.5327,
    stroke: "white",
    strokeWidth: 2.34
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 55.7762,
    y1: 88.7057,
    x2: 49.5362,
    y2: 30.9857,
    stroke: "white",
    strokeWidth: 2.34
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.17,
    y: 88.1898,
    width: 91.26,
    height: 4.68,
    stroke: "white",
    strokeWidth: 2.34
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9707 16.04L14.4307 2H22.2307L18.7207 10.97H26.1307L13.2607 25.79L15.2107 16.04H8.9707Z",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4707 16.04L72.9307 2H80.7307L77.2207 10.97H84.6307L71.7607 25.79L73.7107 16.04H67.4707Z",
    stroke: "white",
    strokeWidth: 2.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon-6.444a2be96765ea3ca6afff348780ffaf.svg";
export { ForwardRef as ReactComponent };